import { PurchaseOrderStatus } from '../constants/purchase-order-status.js';
/** Issue, cancel, and full header edits are all Draft-only. */
export const PURCHASE_ORDER_DRAFT_STATUS_IDS = [PurchaseOrderStatus.DRAFT];
//# sourceMappingURL=purchase-order-draft-status-ids.js.map